export const ACTION_COMPLETE = 'complete';
export const ACTION_ENTRY = 'entry';
